




















































































































































import { Component, Vue, Prop, Emit } from 'vue-property-decorator';
import VWidget from '@/components/VWidget.vue';
import Util from '@/lib/util';
import ListBase from '@/lib/listbase';
import Capacity from '@/store/entities/casis/capacity';


@Component({
    components: { VWidget },
    watch: {
        dealers: function (val) {
            (this as any).loadData();
        },
        red: function (val) {
            (this as any).loadData();
        }
    }
})

export default class CapacityForm extends ListBase {
    period: any = parseInt(Util.abp.clock.today().substr(0, 4));
    changed: boolean = false;
    //capacity: Capacity = new Capacity();
    listValues: Array<any> = new Array<any>();
    totals: Array<any> = new Array<any>();
    
    /***** computed methods *****/
    get loading() {
        return this.$store.state.capacity.loading;
    }

    get list() {
        return this.$store.state.capacity.list;
    }

    get periods() {
        return this.gCommonList('years');
    }

    get months() {
        let list = this.gCommonList('months');
        list.forEach(m => {
            m['field'] = 'month_' + m.id;
        });
        return list;
    }

    get groups() {
        return Util.abp.list.getList('G_CAPACITY');
    }

    get dealers() {
        return this.$store.state.app.dealers;
    }

    get dealer() {
        return this.$store.state.app.dealer;
    }

    get red() {
        return this.$store.state.app.red;
    }

    get capacity() {
        if (this.list[0] == undefined) return null;
        if (this.list[0].capacity_id == null) return null;
        return {
            id: this.list[0].capacity_id,
            month: this.list[0].capacity_month,
            state: this.list[0].capacity_state,
            published: this.list[0].capacity_published,
        };
    }

    get lastMonth() {
        if (this.capacity == null) return this.months[0];

        return this.months[this.capacity.month - 1];
    }

    get nextMonth() {
        if (this.capacity == null) return this.months[0];

        let month = this.capacity.month - 1;
        if (this.capacity.published && month <= 10) month++;
        return this.months[month];
    }

    get state() {
        if (this.capacity == null) return Util.abp.list.get('E_CAPACITY','DI');
        return Util.abp.list.getItem(this.capacity.state);
    }

    /***** fields events *****/
    columns(group: string) {
        let cols = [{ value: 'concept_name', text: group.toUpperCase(), type: 'text', sortable: false, align: 'start', width: '280px', class: '' }];

        this.months.forEach(m => {
            let cClass = (this.capacity != null && m.field == ('month_' + this.capacity.month) ? 'selected-month' : '');
            if (this.capacity != null && this.capacity.published && this.capacity.month == 12) cClass = '';
            cols.push({ value: m.field, text: m.name, type: 'text', width: '85px', sortable: false, align: 'center', class: cClass });
        });
        cols.push({ value: 'total', text: 'TOTAL', type: 'text', width: '65px', sortable: false, align: 'center', class: '' });
        return cols;
    }
    
    setList() {
        this.listValues = [];
        this.groups.forEach(gru => {
            this.listValues[gru.id] = [];

            this.list.forEach(item => {
                if (item.group_id == gru.id)
                    this.listValues[gru.id].push(item);
            });
        });            
    }

    updateTotal(item) {
        this.changed = true;
        item.total = 0;
        this.months.forEach(m => {
            item.total += (item[m.field] == null || item[m.field] == '' ? 0 : parseFloat(item[m.field]));
        });
        this.setTotals();
    }

    setTotals() {
        this.totals = [];
        this.groups.forEach(gru => {
            this.totals[gru.id] = {total: 0};

            this.months.forEach(m => {
                this.totals[gru.id][m.field] = 0;
            });

            if (this.listValues[gru.id] != undefined) {
                this.listValues[gru.id].forEach(item => {
                    this.months.forEach(m => {
                        this.totals[gru.id][m.field] += parseFloat((item[m.field] != undefined && item[m.field] != '' ? item[m.field] : 0));
                    });
                });

                this.months.forEach(m => {
                    this.totals[gru.id].total += this.totals[gru.id][m.field];
                });
            }

            this.totals[gru.id].total = parseFloat(this.totals[gru.id].total.toFixed(2));
        });
    }

    getInitials(string) {
        return Util.getInitials(string);
    }

    onFocus(e) {
        e.target.select();
    }

    async exportData() {
        let filename = await this.$store.dispatch({
            type: 'capacity/export',
            data: {
                year: this.period,
                dealer: this.dealer,
                red: this.red
            }
        });
        if (filename != '' && filename != undefined)
            window.location = filename;
    }

    async create() {
        
        await this.$store.dispatch({
            type: 'capacity/create',
            data: {
                dealer_id: this.dealer,
                year: this.period,
                month: this.nextMonth.id
            }
        });
        await this.loadData();
    }

    async save(publish = false) {
        if (this.capacity != null) {
            let model = Util.extend(true, {}, this.capacity);
            model.concepts = [];

            if (publish)
                model.state = Util.abp.list.get('E_CAPACITY', 'PU').id;

            this.list.forEach(item => {
                model.concepts.push({
                    capacity_id: item.capacity_id,
                    concept_id: item.concept_id,
                    year: item.year,
                    month: item.capacity_month,
                    amount: item['month_' + item.capacity_month],
                });
            });

            await this.$store.dispatch({
                type: 'capacity/update',
                data: model
            });
            await this.loadData();
        }
    }

    async loadData() {
        await this.$store.dispatch({
            type: 'capacity/getAll',
            data: {
                year: this.period,
                dealer: this.dealers,
                red: this.red
            }
        });
        this.setList();
        this.setTotals();
    }

    async mounted() {
        await this.loadData();
    }

    async created() {
    }
}
